import { typography } from '@dixa/lib-shared-tokens';

/** Based on messenger authentication type prep data for the UI component */
export const getMessageWithColor = (
  isVerifiedUser: boolean,
): { color: string; message: string } =>
  isVerifiedUser
    ? {
        color: typography.color['secondary'],
        message:
          'This user identity has been authenticated before the start of this conversation.',
      }
    : {
        color: typography.color['warning'],
        message:
          'Anonymous user or user has identified themselves by name and email.',
      };
